// extracted by mini-css-extract-plugin
export default {"parameterWrapper":"_2-M_VuSBVzzokbHiYPjttx","weightage":"_1myP_0lwqslidOF3ARrtii","errorMsg":"_3Z54KCCeWb-j1YMjWex49X","table":"_2EYy7wWgleyY0jvlmQBoBD"};